import React, { useState } from "react";
import styles from "./styles.module.scss";
import clsx from "classnames";
import Globe from "../../../public/icons/branch-globe.svg";
import Link from "next/link";
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

export default function BranchList({ branches }) {
  // State for current active Tab
  const [currentActiveTab, setCurrentActiveTab] = useState("10");

  // Toggle active state for Tab
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  return (
    <section className={styles.branches}>
      <Container>
        <div className={styles.branches_wrapper} data-aos="fade" data-aos-delay="350" data-aos-once="true">
          <h1 className="h2 mb-40">Find Your Nearest Blue Arrow Branch</h1>
          <div>
            <Nav className={styles.branches_tabs} tabs>
              <NavItem>
                <NavLink
                  className={clsx({ active: currentActiveTab === "10" })}
                  onClick={() => {
                    toggle("10");
                  }}
                >
                  <div className={styles.globe}>
                    <Globe />
                  </div>
                  All
                </NavLink>
              </NavItem>
              {branches
                .sort((a, b) => {
                  a = a.order;
                  b = b.order;
                  return a < b ? -1 : a > b ? 1 : 0;
                })
                .map((branch, index) => (
                  <React.Fragment key={index}>
                    {branch.parent.id === null && branch.hide !== true ? (
                      <>
                        {branch.order ? (
                          <NavItem>
                            <NavLink
                              className={clsx({ active: currentActiveTab === branch.order.toString() })}
                              onClick={() => {
                                toggle(branch.order.toString());
                              }}
                            >
                              <div className={styles.globe}>
                                <Globe />
                              </div>
                              {branch.name.replace("Parent-", "")}
                            </NavLink>
                          </NavItem>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ))}
            </Nav>
            <TabContent activeTab={currentActiveTab}>
              <TabPane tabId={"10"}>
                <div className={styles.branches_list}>
                  {branches
                    .sort((a, b) => {
                      a = a.name;
                      b = b.name;
                      return a < b ? -1 : a > b ? 1 : 0;
                    })
                    .map((subbranch, index) => (
                      <React.Fragment key={index}>
                        {subbranch.parent.id ? (
                          <div>
                            <Link className={styles.branch} href={`our-branches/${subbranch.url_slug}`} target="_blank">
                              <h6>{subbranch.name}</h6>
                              <div className={styles.branch_details}>
                                {subbranch.phone ? <div>{subbranch.phone}</div> : ""}
                                {subbranch.email ? <div>{subbranch.email}</div> : ""}
                                {subbranch.address ? (
                                  <div dangerouslySetInnerHTML={{ __html: subbranch.address }} />
                                ) : (
                                  ""
                                )}
                              </div>
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}
                      </React.Fragment>
                    ))}
                </div>
              </TabPane>
              {branches
                .sort((a, b) => {
                  a = a.name.toLowerCase();
                  b = b.name.toLowerCase();
                  return a < b ? -1 : a > b ? 1 : 0;
                })
                .map((branch, index) => (
                  <React.Fragment key={index}>
                    {branch.parent.id ? (
                      ""
                    ) : (
                      <>
                        {branch.order ? (
                          <TabPane tabId={branch.order.toString()}>
                            <div className={styles.branches_list}>
                              {branches.map((subbranch, index) => (
                                <React.Fragment key={index}>
                                  {subbranch.parent.id === branch.id ? (
                                    <div>
                                      <Link className={styles.branch} href={`our-branches/${subbranch.url_slug}`}>
                                        <h6>{subbranch.name}</h6>
                                        <div className={styles.branch_details}>
                                          {subbranch.phone ? <div>{subbranch.phone}</div> : ""}
                                          {subbranch.email ? <div>{subbranch.email}</div> : ""}
                                          {subbranch.postcode ? <div>{subbranch.postcode}</div> : ""}
                                        </div>
                                      </Link>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </React.Fragment>
                              ))}
                            </div>
                          </TabPane>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </React.Fragment>
                ))}
            </TabContent>
          </div>
        </div>
      </Container>
    </section>
  );
}
